import { Group, Mesh } from 'three/webgpu'
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'
import type { VesselConfig } from '../physics/Vessel.ts'

export type LargeShipKind = 'container-ship' | 'aircraft-carrier'
export function isLargeShip(kind: string): kind is LargeShipKind {
  return kind === 'container-ship' || kind === 'aircraft-carrier'
}

// Full-size hulls with accessible arcade propulsion and a steady, gradual helm.
export const LARGE_SHIP_CONFIG: Record<LargeShipKind, VesselConfig> = {
  'container-ship': {
    name: 'Ocean Atlas', mass: 150_000_000, length: 402, beam: 60, draft: 13,
    dragForward: 360_000, dragLateral: 6_000_000, dragYaw: 8e11,
    yawInertiaScale: 1.2, lateralResistanceOffset: 22,
    buoyancySamples: [14, 4], pitchDamping: 1, rollDamping: 1,
  },
  'aircraft-carrier': {
    name: 'Horizon', mass: 90_000_000, length: 334, beam: 80, draft: 11.5,
    dragForward: 280_000, dragLateral: 5_000_000, dragYaw: 5e11,
    yawInertiaScale: 1.2, lateralResistanceOffset: 18,
    buoyancySamples: [14, 4], pitchDamping: 1, rollDamping: 1,
  },
}
export const LARGE_SHIP_PROPULSION = {
  'container-ship': { ahead: 70_000_000, astern: 32_000_000, rudder: .4, lift: 4_000_000 },
  'aircraft-carrier': { ahead: 65_000_000, astern: 30_000_000, rudder: .4, lift: 3_000_000 },
}

/** Each load owns its textures/geometry. Native +X bow becomes Hawser's +Z. */
export async function loadLargeShipModel(kind: LargeShipKind): Promise<Group> {
  const { scene } = await new GLTFLoader().loadAsync(`/models/large-ships/${kind}.glb`)
  scene.rotation.y = -Math.PI / 2
  const vessel = new Group()
  vessel.name = `${kind}-blender`
  vessel.add(scene)
  vessel.traverse(object => {
    if (!(object as Mesh).isMesh) return
    object.castShadow = true
    object.receiveShadow = true
  })
  return vessel
}
